/** Opções de modelos por provedor (Anthropic, OpenAI, DeepSeek). */
export const MODEL_OPTIONS = {
  anthropic: [
    { value: "claude-sonnet-4-5", label: "Claude Sonnet 4.5 (Padrão)" },
    { value: "claude-3-7-sonnet-20250219", label: "Claude 3.7 Sonnet" },
    { value: "claude-3-5-sonnet-20240620", label: "Claude 3.5 Sonnet" },
    { value: "claude-3-haiku-20240307", label: "Claude 3 Haiku (Mais rápido)" },
    { value: "claude-3-opus-20240229", label: "Claude 3 Opus" },
  ],
  openai: [
    { value: "gpt-5.2", label: "GPT-5.2 (Padrão)" },
    { value: "gpt-5", label: "GPT-5" },
    { value: "gpt-4o", label: "GPT-4o" },
    { value: "gpt-4o-mini", label: "GPT-4o Mini (Econômico)" },
    { value: "gpt-4-turbo", label: "GPT-4 Turbo" },
    { value: "gpt-3.5-turbo", label: "GPT-3.5 Turbo" },
  ],
  deepseek: [
    { value: "deepseek-chat", label: "DeepSeek Chat / V3.2 (Padrão)" },
    { value: "deepseek-reasoner", label: "DeepSeek Reasoner (V3.2 thinking)" },
    { value: "deepseek-coder", label: "DeepSeek Coder" },
  ],
};

export function defaultCustomizationState() {
  return {
    colors: {
      primary: "#0000FF",
      secondary: "#FFFFFF",
      botBubble: "#e9ecef",
      userBubble: "#007BFF",
    },
    logo: "",
    favicon: "",
    headerText: "Chat do Neurobot",
    welcomeMessage: "Olá! Estou aqui para ajudar. Digite sua pergunta abaixo 👇",
    footerText: "Desenvolvido por tilti.io",
    llmProvider: "anthropic",
    llmModel: "claude-sonnet-4-5",
  };
}
